import { Action, Middleware, Store } from 'redux';

import { hasSealsAndSignaturesPermission } from '@paragon/login-tools';
import { enqueueInfo } from '@paragon/notification-tools';

import { RootState } from '../store';

const JOB_LOCKED_MESSAGE = 'Job has been locked for editing. Please contact the sealing engineer.';

export class JobLockedError {
  // TODO: extend error when transpiling is fixed
}

let reduxStore: Store<RootState, Action>;

export function configureJobUnlocker(passedReduxStore: Store<RootState, Action>) {
  reduxStore = passedReduxStore;
}

/**
 * If the current job is locked, displays an error message and returns true.
 */
export function jobIsLocked() {
  const state = reduxStore.getState();
  const currentJobIsLocked = state.job.isLocked;

  if (currentJobIsLocked && !hasSealsAndSignaturesPermission(state)) {
    reduxStore.dispatch(enqueueInfo(JOB_LOCKED_MESSAGE));
    return true;
  }

  return false;
}

/**
 * If the current job is locked, displays an error message and throws a `JobLockedError`.
 */
export function proceedOnlyIfJobIsUnlocked() {
  if (jobIsLocked()) {
    throw new JobLockedError();
  }
}

export const jobLockingMiddleware: Middleware = () => (next) => (action) => {
  try {
    return next(action);
  } catch (err) {
    if (err instanceof JobLockedError) {
      return Promise.resolve();
    }
    throw err;
  }
};
